import { lazy, Suspense, Component } from 'react'
import Loader from 'components/Loader'
import Icon from 'components/Icon'
import Container from 'components/Container'
import Type from 'components/Type'
import Stack from '@mui/material/Stack'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.props.onError(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      if (typeof window.sessionStorage !== 'undefined' && !window.sessionStorage?.getItem('attemptedCacheBust')) {
        window.sessionStorage?.setItem('attemptedCacheBust', true)
        caches.keys().then(names => {
          for (let name of names) caches.delete(name)
        })
        window.location.reload(true)
      }
      // You can render any custom fallback UI
      return (
        <Container
          style={{
            height: '100%',
            alignSelf: 'center',
          }}
          py={6}
        >
          <Stack
            sx={{
              height: '100%',
              display: 'grid',
              placeItems: 'center',
              placeContent: 'center',
              gap: 2,
            }}
          >
            <Icon
              icon="BadJS"
              // height="100"
              // width="100"
            />
            <Stack
              gap={1}
              textAlign="center"
            >
              <Type
                variant="sectionLabel"
              >
                Something went wrong!
              </Type>
              <Type
                variant="data"
                color="neutralCool_700"
                maxWidth="370px"
              >
                We couldn’t load this page. Our team is aware of this problem and are fixing it. Please try again later.
              </Type>
            </Stack>
          </Stack>
        </Container>
      )
    }

    return this.props.children 
  }
}

const lazyRetry = function(componentImport) {
  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(window.sessionStorage.getItem('retry-lazy-refreshed') || 'false')
    componentImport().then((component) => {
      window.sessionStorage.setItem('retry-lazy-refreshed', 'false')
      resolve(component)
    }).catch((error) => {
      if (!hasRefreshed) {
        window.sessionStorage.setItem('retry-lazy-refreshed', 'true')
        return window.location.reload()
      }
      reject(error)
    })
  })
}

const loadable = (importFunc, { fallback = null } = { fallback: null }) => {
  const LazyComponent = lazy(() => lazyRetry(importFunc))

  return ({
    onError,
    ...props
  }) => (
    <ErrorBoundary
      onError={onError}
    >
      <Suspense 
        fallback={<Loader position="fixed" variant="primary" />}
      >
        <LazyComponent {...props} />
      </Suspense>
    </ErrorBoundary>
  )
}

export default loadable
